export default __webpack_public_path__ + "static/media/social-telegram.9126bb47.svg";